module.exports = __webpack_public_path__ + "img/user_avatar.470f1c48.svg";